import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo, useRef } from "react";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { FORM_PRINT } from "app/common/LocalConst";
import { useReactToPrint } from "react-to-print";
import PrintVoucherTemporaryForm from "../Print/PrintVoucherTemporaryForm";
import { POSITION_CONSULTANT } from "app/appConfig";

const PrintPopupTemporary = ({
  open,
  handleClose,
  selectedItems,
  listInvoiceItems,
  qrCode,
  voucherPaymentMethods,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "In phiếu",
  });

  return (
    <PopupForm
      open={open}
      size="xxl"
      height="75vh"
      handleClose={handleClose}
      title={"In phiếu"}
      formik={{
        initialValues: {},
        onSubmit: async (values) => {
          console.log("Data", values);
        },
        enableReinitialize: true,
      }}
      action={(values) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" onClick={handlePrint}>
              {!isMobile && <Save className="mr-2 " />}
              In phiếu
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              componentRef={componentRef}
              selectedItems={selectedItems}
              qrCode={qrCode}
              voucherPaymentMethods={voucherPaymentMethods}
              listInvoiceItems={listInvoiceItems}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({
    componentRef,
    selectedItems,
    qrCode,
    voucherPaymentMethods,
    listInvoiceItems,
  }) => {
    const staffRevenuesConsultant =
      listInvoiceItems?.items?.length > 0 &&
      listInvoiceItems?.items?.flatMap((el) =>
        el?.staffRevenues?.filter(
          (el) => el?.position?.code === POSITION_CONSULTANT
        )
      );
    console.log("ggggg", listInvoiceItems);
    return (
      <>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <GlobitsSelectInput
              label="Loại mẫu phiếu"
              name="methodPrint"
              options={FORM_PRINT}
            />
          </Grid>
          <Grid
            item
            xs={12}
            className="flex-center"
            style={{ border: "1px dashed black", margin: "5px" }}
          >
            <PrintVoucherTemporaryForm
              componentRef={componentRef}
              selectedItems={selectedItems}
              qrCode={qrCode}
              voucherPaymentMethods={voucherPaymentMethods}
              listInvoiceItems={listInvoiceItems}
              staffRevenues={staffRevenuesConsultant}
            />
          </Grid>
        </Grid>
      </>
    );
  }
);

export default memo(observer(PrintPopupTemporary));
